<template>
  <div>
    <el-form ref="form" size="small" :model="formData" :rules="rules">
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_reviewStatus') || '审核结果'"
            prop="reviewStatus"
          >
            <el-radio-group v-model="formData.reviewStatus">
              <el-radio-button label="Y">{{'通过'}}</el-radio-button>
              <el-radio-button label="N">{{'不通过'}}</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_reviewDesc') || '审核意见'"
            prop="reviewDesc"
          >
            <el-input
              v-model="formData.reviewDesc"
              type="textarea"
              :rows="4"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              maxlength="100"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    amzFirstDemandCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {
        reviewStatus: '',
      },
      backDialogVisible: false,
    }
  },
  computed: {
    rules() {
      return {
        reviewStatus: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'blur',
          },
        ],
        reviewDesc: [
          {
            required: this.formData.reviewStatus == 'N',
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
      }
    },
  },
  methods: {
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      if (this.loadingOpen()) return
      const reviewStatus = this.formData.reviewStatus
      const params = { ...this.formData, amzFirstDemandCode: this.amzFirstDemandCode }
      let res
      if (reviewStatus == 'N') {
        res = await this.$api
          .ecomAmzFirstDemandRejectApi(params)
          .catch(() => null)
      } else {
        res = await this.$api
          .ecomAmzFirstDemandReviewApi(params)
          .catch(() => null)
      }
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_operate_no') || '操作失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_operate_ok') || '操作成功！',
        type: 'success',
      })
      this.close()
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
